var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.82812,122.82861v-.00049L221.1709,96.48584a11.99858,11.99858,0,0,0,0-16.97119L176.48535,34.82812a12.01526,12.01526,0,0,0-16.9707.00049l-120.001,120a11.95868,11.95868,0,0,0-2.69995,4.15235c-.01172.02783-.01953.05713-.03052.08545A11.98566,11.98566,0,0,0,36,163.31348V208a12.01343,12.01343,0,0,0,12,12H216a4,4,0,0,0,0-8H105.65649l89.17163-89.17139ZM165.1709,40.48584a4.00622,4.00622,0,0,1,5.6582-.00049l44.68555,44.68653a3.99913,3.99913,0,0,1,0,5.65673l-23.51489,23.51465L141.65649,64ZM45.65637,160,136,69.65625,186.34326,120,96,210.34277ZM44,208V169.65625L86.34351,212H48A4.00427,4.00427,0,0,1,44,208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.68841b42af41511daf0b959611ff76ad.svg";
export { ForwardRef as ReactComponent };